import React from "react";

import background from '@cover/weitertesten/background-1.jpg';
import backgroundSm from '@cover/weitertesten/background-1-sm.jpg';
import WeiterTesten from "../components/cover/animations/weitertesten";

import eyeSrc from '@assets/eye.svg';
import articleSrc from '@assets/article.svg';

export const meta = {
	category: "continue",
	slug: "testen",
	id: "WeiterTesten",
	excerpt: {
		before: "Dr. Maximilian Kittel und das Team von der Universitätsmedizin Mannheim sind seit Juli 2020 mit dem CoVLAB unterwegs, der ersten mobilen Corona-Teststation in Baden-Württemberg."
	},
	name: "weitertesten",
	title: "Labor auf Rädern",
	animation: WeiterTesten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		alt: "Assistenzarzt Maximilian Kittel lächelt sichtlich - trotzt Mundschutz. Um ihm schweben drei Petri-Schalen mit je einem großen SARS-Cov-2-Erreger darin. Eine Hand im Vordergrund hält ein Test-Stäbchen in der Hand."
	}
}

const WeitertestenArticle = () => {
	return (
		<div>
			<p className="articleStatement articleStatement--large">
				„Unser Testgerät ist die Nespresso-Maschine der molekulargenetischen Testung. Damit können wir täglich bis zu 500 Messdurchläufe durchführen.“ 
			</p>
			<p className="articleHint">
				Dr. Maximilian Kittel und das Team von der Universitätsmedizin Mannheim sind seit Juli 2020 mit dem CoVLAB unterwegs, der ersten mobilen Corona-Teststation in Baden-Württemberg.  
			</p>
			<a href="https://www.bwstiftung.de/fileadmin/bw-stiftung/Publikationen/Perspektive/Perspektiven_Magazin_Mut_01_2021_BWS.pdf#page=48" target="_blank" className="articleLink articleLink--block">
			 <div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Mut machen: Mobiles Corona-Testlabor
					<div className="articleLinkSource">
						Perspektiven 01/2021
					</div>
				</div>
			</a>
			<a href="https://www.covlab.de/startseite/" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					CoVLAB
					<div className="articleLinkSource">
						www.covlab.de
					</div>
				</div>
			</a>
			<a href="https://www.youtube.com/watch?v=zuLH5HI2HYM" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={eyeSrc} />
				</div>
				<div>
					CoVLAB | Unser Beitrag | Imagefilm 
					<div className="articleLinkSource">
						bwstiftung - YouTube
					</div>
				</div>
			</a>
		</div>
	)
};

export default WeitertestenArticle;